import { render, staticRenderFns } from "./LoadingInspection.vue?vue&type=template&id=ed4ff032&scoped=true&"
import script from "./LoadingInspection.vue?vue&type=script&lang=js&"
export * from "./LoadingInspection.vue?vue&type=script&lang=js&"
import style0 from "./LoadingInspection.vue?vue&type=style&index=0&id=ed4ff032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4ff032",
  null
  
)

export default component.exports